import { useSelector } from 'react-redux'

function CancelModalButton({ text, customFn, disabled }) {
  const languageRedux = useSelector(
    (state) => state.language?.language?.data?.general
  )

  const language = languageRedux || {}

  return (
    <button
      {...(disabled !== undefined ? { disabled } : {})}
      type='button'
      className='btn btn-transparent text-info'
      onClick={() => customFn && customFn()}
    >
      {text ? text : language.cancel}
    </button>
  )
}

export default CancelModalButton
